import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import Logo from "../../Assets/images/logo.webp";

function NavBar() {
    const [collapse, setCollapse] = useState(false);

    const links = [
        { name: "About Us", path: "/about" },
        { name: "Resources", path: "/resources" },
        { name: "Gallery", path: "/gallery" },
        { name: "Contact Us", path: "/contact" },
    ];

    return (
        <nav className="flex flex-col md:flex-row items-center justify-between w-full max-w-[1280px] mx-auto px-4 2xl:px-0 py-2">
            {/* Top row: logo + hamburger */}
            <div className="flex justify-between items-center w-full md:w-auto">
                <Link to="/">
                    <img src={Logo} alt="logo" className="w-24 h-20 object-contain" />
                </Link>

                {/* Hamburger Menu Button */}
                <div className="md:hidden">
                    <FontAwesomeIcon
                        size="2x"
                        icon={faBars}
                        onClick={() => setCollapse(!collapse)}
                        className="cursor-pointer"
                    />
                </div>
            </div>

            {/* Desktop Menu */}
            <ul className="hidden md:flex flex-row space-x-6">
                {links.map((link) => (
                    <li key={link.name}>
                        <Link
                            to={link.path}
                            className="text-gray-800 hover:text-blue-600 font-medium"
                        >
                            {link.name}
                        </Link>
                    </li>
                ))}
            </ul>

            {/* Mobile Menu */}
            {collapse && (
                <ul className="flex flex-col md:hidden space-y-4 mt-2 w-full text-center bg-white py-4">
                    {links.map((link) => (
                        <li key={link.name}>
                            <Link
                                to={link.path}
                                onClick={() => setCollapse(false)}
                                className="text-gray-800 hover:text-blue-600 font-medium"
                            >
                                {link.name}
                            </Link>
                        </li>
                    ))}
                </ul>
            )}
        </nav>

    );
}

export default NavBar;
